import types from 'constants/actionTypes';
import { combineReducers } from 'redux';

const initialState = {
  byId: {},
  selectedSeriesId: null,
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_SERIES_PIPELINE_REQUEST_SUCCESS:
      const { seriesId, responseBody: pipelineByBodyStyleId } = payload;
      const series = {};
      series[seriesId.id] = pipelineByBodyStyleId;
      return { ...state, ...series };
    default:
      return state;
  }
};

const selectedSeriesId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.selectedSeriesId;
  }

  switch (type) {
    case types.SET_SELECTED_SERIES_ID:
      return payload;
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  selectedSeriesId,
});
